import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-dialogs-header',
  templateUrl: './dialogs-header.component.html',
  styleUrls: ['./dialogs-header.component.scss']
})
export class DialogsHeaderComponent implements OnInit {
  @Output() closeDialog = new EventEmitter<object>();
  @Input() title:string

  constructor() { }

  ngOnInit() {
  }
  cancel(){
    this.closeDialog.emit()
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/dialogs-header/dialogs-header.component.ts